import styled from "styled-components";
import { Link } from "react-router-dom";

const DashboardCard = styled(Link)`
  width: 100%;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: ${(props) => props.$accent || "#94a3b8"};
    border-radius: 4px 0 0 4px;
    opacity: 0.7;
    transition: opacity 0.25s ease;
  }

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    border-color: #e2e8f0;
    transform: translateY(-2px);

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 640px) {
    min-height: 100px;
    padding: 16px 18px;
  }
`;

export const CardLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
  margin-bottom: 8px;
  letter-spacing: 0.02em;
`;

export const CardValue = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;

  @media (max-width: 640px) {
    font-size: 22px;
  }
`;

export default DashboardCard;
